import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import FloatingContact from '../../../components/feature/FloatingContact';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const CommercialProjects = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <FloatingContact />

      {/* Hero Section */}
      <section className="pt-24 md:pt-32 pb-12 md:pb-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-20">
          <div className="max-w-4xl">
            <p className="text-mid-gray text-xs uppercase tracking-[0.3em] mb-4 font-sans">
              Hizmetler
            </p>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-dark-gray leading-tight mb-6">
              Ticari Alanlar
            </h1>
            <p className="font-sans text-base md:text-lg text-mid-gray leading-relaxed">
              İş dünyasının dinamiklerine yanıt veren, fonksiyonel ve prestijli mekânlar
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-12 md:py-16 lg:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-8 lg:px-20">
          <article className="prose prose-lg max-w-none">
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6 md:mb-8">
              Ticari alan tasarımı, işlevsellik ve estetik arasında hassas bir denge kurmayı gerektirir. Ofisler, showroomlar, perakende mekânları ve kurumsal binalar, yalnızca iş süreçlerini desteklemekle kalmaz; aynı zamanda kurumsal kimliği yansıtan, çalışan verimliliğini artıran ve müşteri deneyimini zenginleştiren mekânlar olarak tasarlanmalıdır.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Kurumsal Kimlik ve Mekân
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Her ticari mekân, kurumun değerlerini ve vizyonunu yansıtan bir arayüz görevi görür. Tasarım süreci, kurumsal kimliğin mimari dile çevrilmesiyle başlar. Renk paleti, malzeme seçimi, mekânsal organizasyon ve detay çözümleri, markanın karakterini somutlaştırır.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Modern ticari mekânlarda şeffaflık ve açıklık önemli unsurlardır. Cam bölmeler, açık ofis düzenleri ve ortak kullanım alanları, iletişimi kolaylaştırır ve işbirliğini teşvik eder. Ancak bu açıklık, gürültü kontrolü ve mahremiyet ihtiyaçlarıyla dengelenmelidir.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Çalışan Verimliliği ve Konfor
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Ofis tasarımında çalışan konforu ve verimliliği önceliklidir. Ergonomik mobilyalar, ayarlanabilir aydınlatma sistemleri ve uygun akustik çözümler, çalışma ortamının kalitesini artırır. Doğal ışık ve havalandırma, çalışanların fiziksel ve zihinsel sağlığını doğrudan etkiler.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Esnek çalışma alanları, değişen iş pratiklerine adaptasyonu kolaylaştırır. Bireysel çalışma masaları, toplantı odaları, sessiz odalar ve sosyal alanlar, farklı çalışma tarzlarına yanıt verir. Modüler mobilya sistemleri, mekânın ihtiyaca göre yeniden düzenlenmesine olanak tanır.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Müşteri Deneyimi ve Perakende Tasarımı
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Perakende mekânlarında müşteri deneyimi, satış performansını doğrudan etkiler. Mağaza girişi, ürün sergileme alanları, deneme kabinleri ve ödeme noktaları, müşteri yolculuğunu kolaylaştıracak şekilde planlanır. Görsel merchandising, aydınlatma ve malzeme seçimi, ürünlerin en iyi şekilde sunulmasını sağlar.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Showroom tasarımında ürün odaklı yaklaşım benimsenir. Her ürün, özel aydınlatma ve sergileme sistemleriyle vurgulanır. Mekânsal sirkülasyon, ziyaretçilerin tüm ürünleri rahatça görmesini sağlayacak şekilde düzenlenir. Oturma alanları ve danışma noktaları, müşteri konforunu artırır.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Teknoloji Entegrasyonu
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Modern ticari mekânlarda teknoloji altyapısı kritik öneme sahiptir. Veri kablolaması, kablosuz ağ sistemleri, sunucu odaları ve teknik altyapı, tasarım sürecinin başından itibaren planlanır. Akıllı bina sistemleri, enerji yönetimi, güvenlik ve konfor kontrolünü merkezi olarak sağlar.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Toplantı odaları ve sunum alanları, en son görüntü ve ses teknolojileriyle donatılır. Video konferans sistemleri, interaktif ekranlar ve kablosuz sunum çözümleri, iş süreçlerini destekler. Teknolojik donanım, mekânın estetik bütünlüğünü bozmayacak şekilde entegre edilir.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Sürdürülebilir Ticari Binalar
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Ticari binalarda enerji verimliliği, hem çevresel sorumluluk hem de işletme maliyetleri açısından önemlidir. Yüksek performanslı cam cepheler, güneş kırıcılar ve yeşil çatı uygulamaları, enerji tüketimini azaltır. LED aydınlatma sistemleri ve hareket sensörleri, elektrik tüketimini optimize eder.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              LEED ve BREEAM gibi yeşil bina sertifikasyonları, sürdürülebilir tasarım uygulamalarının belgelenmesini sağlar. Su tasarrufu sistemleri, atık yönetimi ve iç hava kalitesi standartları, çevresel performansı artırır. Bu uygulamalar, binanın piyasa değerini ve prestijini de yükseltir.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Cephe Tasarımı ve Kentsel Bağlam
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Ticari binaların cephe tasarımı, kentsel peyzajla diyalog kurar. Malzeme seçimi, oran-orantı ve detay çözümleri, binanın çevreyle uyumunu sağlar. Cam, metal, taş ve beton gibi malzemeler, modern ve prestijli bir görünüm yaratır.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Giriş tasarımı, binanın kimliğini en güçlü şekilde ifade eden alandır. Geniş ve davetkar girişler, yüksek tavanlar ve kaliteli malzemeler, prestij hissi yaratır. Peyzaj düzenlemesi, binanın sokakla ilişkisini güçlendirir ve kentsel yaşam kalitesine katkı sağlar.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Güvenlik ve Erişilebilirlik
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Ticari binalarda güvenlik sistemleri, kullanıcı konforunu etkilemeden entegre edilmelidir. Kartlı geçiş sistemleri, güvenlik kameraları ve alarm sistemleri, mekânın güvenliğini sağlarken estetik bütünlüğü korur. Yangın güvenliği, acil çıkış yolları ve tahliye planları, yasal gerekliliklerin ötesinde tasarlanır.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Evrensel tasarım ilkeleri, tüm kullanıcıların mekâna rahatça erişimini sağlar. Rampalar, asansörler, geniş koridorlar ve erişilebilir tuvaletler, engelsiz bir ortam yaratır. Yönlendirme sistemleri, görsel ve dokunsal işaretlerle desteklenir.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Ortak Kullanım Alanları
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Modern ofis binalarında ortak kullanım alanları, sosyal etkileşimi ve çalışan memnuniyetini artırır. Kafeteryalar, dinlenme alanları, spor salonları ve teras bahçeleri, çalışanların iş dışı zamanlarını değerlendirmelerine olanak tanır. Bu alanlar, kurumsal kültürü güçlendirir ve çalışan bağlılığını artırır.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Lobi ve bekleme alanları, binanın ilk izlenimini oluşturur. Konforlu oturma grupları, sanat eserleri ve yeşil bitkiler, misafirlere hoş bir karşılama sunar. Resepsiyon tasarımı, profesyonel ve davetkar bir atmosfer yaratır.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Proje Yönetimi ve Uygulama
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Ticari projelerde zaman yönetimi kritik öneme sahiptir. Detaylı proje programları, tüm disiplinlerin koordinasyonunu sağlar. Yapım aşamasında düzenli şantiye toplantıları, sorunların hızlı çözümünü ve kalite kontrolünü garanti eder.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Bütçe yönetimi, proje başarısının temel unsurlarından biridir. Maliyet analizleri, alternatif çözümler ve değer mühendisliği uygulamaları, projenin ekonomik sürdürülebilirliğini sağlar. Teslim sonrası destek ve bakım planlaması, binanın uzun ömürlü kullanımını garanti eder.
            </p>

            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mt-12">
              Ticari alan tasarımı, iş dünyasının dinamik gereksinimlerine yanıt veren, estetik değeri yüksek ve fonksiyonel mekânlar yaratmayı hedefler. Her proje, kullanıcı ihtiyaçlarını, kurumsal kimliği ve çevresel sorumluluğu bir araya getirerek, başarılı iş ortamları sunar.
            </p>
          </article>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-20 bg-cream">
        <div className="max-w-4xl mx-auto px-6 md:px-8 lg:px-20 text-center">
          <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mb-6">
            Ticari Projeniz İçin Görüşelim
          </h2>
          <p className="font-sans text-sm md:text-base text-mid-gray mb-8 max-w-2xl mx-auto">
            İş yerinizi birlikte tasarlayalım
          </p>
          <Link
            to="/iletisim"
            className="inline-block border border-dark-gray text-dark-gray px-8 py-3 text-sm tracking-wide hover:bg-dark-gray hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            İletişime Geçin
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CommercialProjects;
